import { useReducer } from 'react';

export interface State {
  isFetching: boolean;
  error: any | null;
  response: any | null;
  lastFetchAttempt: Date | null;
}

export interface Action {
  type: 'START' | 'ERROR' | 'SUCCESS' | 'RESET';
  error?: any;
  response?: any;
}

export const initialFetchState = {
  isFetching: false,
  error: null,
  response: null,
  lastFetchAttempt: null,
};

export function reducer(state: State, action: Action) {
  const reducers = {
    START: (state: any) => ({
      ...state,
      isFetching: true,
      error: null,
      response: null,
    }),
    ERROR: (_state: any, action: any) => ({
      isFetching: false,
      error: action.error,
      response: action.response,
      lastFetchAttempt: new Date(),
    }),
    SUCCESS: (_state: any, action: any) => ({
      response: action.response,
      error: null,
      isFetching: false,
      lastFetchAttempt: new Date(),
    }),
    RESET: () => initialFetchState,
  };
  return reducers[action.type] ? reducers[action.type](state, action) : state;
}

export const useServiceReducer = () => useReducer(reducer, initialFetchState);
